module.exports = {"320902001":"五星街道","320902002":"文峰街道","320902003":"先锋街道","320902004":"毓龙街道","320902007":"新洋街道","320902008":"大洋街道","320902050":"伍佑街道（城南新区）","320902051":"黄海街道（城南新区）","320902052":"新河街道（城南新区）","320902100":"南洋镇","320902102":"新兴镇","320902104":"便仓镇","320902107":"盐东镇","320902108":"黄尖镇","320902400":"亭湖新区","320902402":"环保产业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320902.json
// module id = 833
// module chunks = 0